interface TrendingDownProps {
  size?: 'small' | 'medium' | 'large'
}

export const TrendingDown = ({ size = 'medium' }: TrendingDownProps) => {
  const getSize = () => {
    switch (size) {
      case 'small':
        return { width: 16, height: 10 }
      case 'medium':
        return { width: 22, height: 14 }
      case 'large':
        return { width: 32, height: 20 }
      default:
        return { width: 22, height: 14 }
    }
  }

  const { width, height } = getSize()

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 22 14" fill="none">
      <path
        d="M21.5004 7.00005V13.0001C21.5004 13.199 21.4214 13.3897 21.2807 13.5304C21.1401 13.671 20.9493 13.7501 20.7504 13.7501H14.7504C14.5515 13.7501 14.3607 13.671 14.2201 13.5304C14.0794 13.3897 14.0004 13.199 14.0004 13.0001C14.0004 12.8011 14.0794 12.6104 14.2201 12.4697C14.3607 12.3291 14.5515 12.2501 14.7504 12.2501H18.9401L11.7504 5.06036L8.53104 8.28068C8.46139 8.35041 8.37867 8.40573 8.28762 8.44347C8.19657 8.48121 8.09898 8.50064 8.00042 8.50064C7.90186 8.50064 7.80426 8.48121 7.71321 8.44347C7.62216 8.40573 7.53945 8.35041 7.46979 8.28068L0.719792 1.53068C0.579062 1.38995 0.5 1.19907 0.5 1.00005C0.5 0.801028 0.579062 0.610156 0.719792 0.469426C0.860523 0.328695 1.05139 0.249634 1.25042 0.249634C1.44944 0.249634 1.64031 0.328695 1.78104 0.469426L8.00042 6.68974L11.2198 3.46943C11.2894 3.39969 11.3722 3.34437 11.4632 3.30663C11.5543 3.26889 11.6519 3.24946 11.7504 3.24946C11.849 3.24946 11.9466 3.26889 12.0376 3.30663C12.1287 3.34437 12.2114 3.39969 12.281 3.46943L20.0004 11.1897V7.00005C20.0004 6.80114 20.0794 6.61037 20.2201 6.46972C20.3607 6.32907 20.5515 6.25005 20.7504 6.25005C20.9493 6.25005 21.1401 6.32907 21.2807 6.46972C21.4214 6.61037 21.5004 6.80114 21.5004 7.00005Z"
        fill="currentColor"
      />
    </svg>
  )
}
